<template>
  <el-dialog
      :visible.sync="visible"
      title="退货"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1000px"
      :append-to-body="true"
  >
    <el-form
        ref="dataForm"
        :model="dataForm"
        label-width="100px"
        :rules="dataRule"
    >
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="12">
          <el-form-item label="外销合同号：">
            {{ dataForm.orderCode }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货批次号：">
            {{ dataForm.batchCode }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货方：">
            {{ dataForm.senderName }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收货方：">
            {{ dataForm.receiverName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="12">
          <el-form-item label="发货数：">
            {{ dataForm.sendCount }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收货数：">
            {{ dataForm.count }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发货时间：">
            {{ dataForm.operateTime }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收货时间：">
            {{ dataForm.receiveOptTime }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="24">
          <el-form-item label="" label-width="0">
            <ProductRowCard :product="dataForm.product"></ProductRowCard>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="12">
          <el-form-item label="备注：">
            {{ dataForm.fullRemark }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="12">
          <el-form-item prop="backCount" label="退货数量：">
            <el-input type="text" size="mini" v-model="dataForm.backCount"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="backRemark" label="退货原因：">
            <el-input type="text" size="mini" v-model="dataForm.backRemark"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="16" style="padding-left: 10px;">
        <el-col :span="12">
          <el-form-item prop="backOperateTime" label="退货时间：">
            <el-date-picker type="date" placeholder="选择日期" size="mini" value-format="yyyy-MM-dd"
                            v-model="dataForm.backOperateTime"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template #footer>
      <el-button size="small" @click="visible = false">取消</el-button>
      <el-button type="primary" size="small" @click="doSubmit">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import ProductRowCard from '@/components/ProductRowCard.vue'
import { isPositiveNumber } from '@/utils/validate'

export default {
  name: 'ChangePriceDialog',
  components: { ProductRowCard },
  data () {
    return {
      visible: false,
      dataForm: {},
      dataRule: {
        backCount: [
          { required: true, message: '请输入退货数量', trigger: 'change' },
          {
            validator: (rule, value, callback, source, options, msg) => {
              console.log(value, isPositiveNumber(value))
              if (!isPositiveNumber(value)) {
                callback(new Error('退货数量必须为正数'))
              }
              if(parseFloat(value) <=0){
                callback(new Error('退货数量必须大于0'))
              }
              callback()
            }, trigger: 'change'
          }
        ],
        backRemark: [{ required: true, message: '请输入退货原因', trigger: 'change' },],
        backOperateTime: [{ required: true, message: '请输入退货时间', trigger: 'change' },]
      }
    }
  },
  methods: {
    init (data) {
      this.dataForm = {
        ...data,
        backRemark: '',
        backCount: 0,
        backOperateTime: moment().format('YYYY-MM-DD')
      }
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.clearValidate()
      })
    },
    async doSave () {
      let postForm = {
        id: this.dataForm.id,
        count: this.dataForm.backCount,
        remark: this.dataForm.backRemark,
        operateTime: this.dataForm.backOperateTime
      }
      let loading = this.$loading({
        lock: true,
        text: '正在提交中...'
      })
      try {
        let res = await this.$api2.post('/trade/factorystorelog/back', postForm)
        this.$message.success('保存成功')
        this.$emit('changed')
        this.visible = false
      } catch (e) {
        console.log(e)
      } finally {
        loading.close()
      }
    },
    doSubmit () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.doSave()
      })
    }
  }
}
</script>

<style scoped>

</style>
